import { ConnectorIds } from '@/common/constants';
import { AuthConfigField, ConnectorAuthTypes } from '@/common/dto/connectors/Interface';
import { IUserConnector } from '@/common/dto/user-connectors/Interface';
import { TagTypes, baseApi } from '@/store/baseApi';

export type ConnectedApp = {
  userConnectorId?: string;
  userId?: string;
  name?: string;
  description?: string;
  connectorId: ConnectorIds;
  authType?: ConnectorAuthTypes;
  authConfigFields?: AuthConfigField[];
  isConnected?: boolean;
};

const baseUrl = '/user-connector';

export const userConnectorsApi = baseApi
  .enhanceEndpoints({ addTagTypes: [TagTypes.UserConnector] })
  .injectEndpoints({
    endpoints: (build) => ({
      deleteUserConnector: build.mutation<IUserConnector, string>({
        query: (id) => ({
          url: `${baseUrl}/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: [TagTypes.Connector, TagTypes.UserConnector],
      }),
      getUserConnectors: build.query<IUserConnector[], void>({
        query: () => baseUrl,
        transformResponse: (res: { items: IUserConnector[] }) => res?.items ?? [],
        providesTags: [TagTypes.UserConnector],
      }),
    }),
  });

export const { useDeleteUserConnectorMutation, useGetUserConnectorsQuery } = userConnectorsApi;
